<template>
  <div
    class="
      tw-flex
      tw-items-center
      tw-px-1.5
      tw-py-1.5
      tw-bg-sf-ai-subtle-1
      tw-rounded-lg
      tw-gap-2
      tw-ml-4
    "
  >
    <span>{{ copy.actionsExplain }}</span>

    <SfButtonDs
      variant="secondary"
      size="sm"
      :disabled="isFinalizingProposal"
      data-testid="reject-process-button"
      @click="handleRejectProposal"
    >
      {{ copy.rejectButton }}
    </SfButtonDs>
    <SfButtonDs
      variant="ai"
      size="sm"
      :disabled="isFinalizingProposal"
      class="tw-bg-sf-ai-light-2"
      data-testid="accept-process-button"
      @click="handleAcceptProposal"
    >
      {{ copy.acceptButton }}
    </SfButtonDs>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'
import useI18n from '@app/shared/vue/composables/use-I18n'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import { useProposalDetailsStore } from '@app/application/client_meetings/screens/past/stores/proposal'

interface Props {
  proposalId: number
}

const props = defineProps<Props>()

const I18n = useI18n()
const copy = {
  actionsExplain: I18n.t(
    'client_meetings.past.meeting_proposal.actions_explain'
  ),
  rejectButton: I18n.t('client_meetings.past.meeting_proposal.reject_button'),
  acceptButton: I18n.t('client_meetings.past.meeting_proposal.accept_button'),
}

const proposalStore = useProposalDetailsStore()
const { isFinalizingProposal } = storeToRefs(proposalStore)

const handleRejectProposal = async () => {
  try {
    await proposalStore.rejectProposal(props.proposalId)
  } catch {
    alert(I18n.t('common.error.try_again'))
  }
}

const handleAcceptProposal = async () => {
  try {
    await proposalStore.acceptProposal(props.proposalId)
  } catch {
    alert(I18n.t('common.error.try_again'))
  }
}
</script>
